import { Box, CircularProgress } from "@mui/material";
import { styles } from "../../assets/styles/components/loaderStyle";

interface LoaderProps {
  show: boolean;
}

export const Loader = ({ show = true }: LoaderProps): JSX.Element => {
  if (show) {
    return (
      <Box sx={styles.boxLoader}>
        <CircularProgress size={135} thickness={0.5} color="success" />
      </Box>
    );
  } else {
    return <></>;
  }
};
